import * as actionTypes from "../actions/actionTypes";
import { api } from "../../common/api-utils";
import { pathOr } from "ramda";
import { toast } from "react-toastify";

const getError = (res) =>
  pathOr("Something went wrong!", ["data", "errors", "detail"], res);
// Sidebar links/data actions
const getSidebarLinksRequest = () => ({
  type: actionTypes.SIDEBAR_LINKS_REQUEST,
});

const getSidebarLinksSuccess = (payload) => ({
  type: actionTypes.SIDEBAR_LINKS_SUCCESS,
  payload,
});

const getSidebarLinksFailure = (error) => ({
  type: actionTypes.SIDEBAR_LINKS_FAILURE,
  error,
});

export const getSidebarLinks = () => async (dispatch) => {
  try {
    dispatch(getSidebarLinksRequest());
    const res = await api.get("/V8/navigation");
    if (res.ok) {
      dispatch(getSidebarLinksSuccess(res.data.data));
      return;
    }
    dispatch(getSidebarLinksFailure(res.data.message));
  } catch (e) {
    dispatch(getSidebarLinksFailure(e));
  }
};


// Dashlet Dialog links/data actions
const getDashletDialogLinksRequest = () => ({
  type: actionTypes.DASHLET_DIALOG_LINKS_REQUEST,
});

const getDashletDialogLinksSuccess = (payload) => ({
  type: actionTypes.DASHLET_DIALOG_LINKS_SUCCESS,
  payload,
});

const getDashletDialogLinksFailure = (error) => ({
  type: actionTypes.DASHLET_DIALOG_LINKS_FAILURE,
  error,
});

export const getDashletDialogLinks = () => async (dispatch) => {
  try {
    dispatch(getDashletDialogLinksRequest());
    const res = await api.get("/V8/dashlet/dialog");
    if (res.ok) {
      dispatch(getDashletDialogLinksSuccess(res.data));
      return;
    }
    dispatch(getDashletDialogLinksFailure(res.data.message));
  } catch (e) {
    dispatch(getDashletDialogLinksFailure(e));
  }
};


// Dashboard data actions
const getDashboardRequest = () => ({
  type: actionTypes.DASHBOARD_REQUEST,
});

const getDashboardSuccess = (payload, tab) => ({
  type: actionTypes.DASHBOARD_SUCCESS,
  payload,
  tab
});

const getDashboardFailure = (error) => ({
  type: actionTypes.DASHBOARD_FAILURE,
  error,
});

export const getCurrentTab = (tab, date_time_period = null) => async (dispatch) => {

  let filter = date_time_period ? `?page[number]=1&filter[date_time_period]=` + date_time_period : '';

  try {
    dispatch(getDashboardRequest());
    const res = await api.get(`/V8/dashboard/` + tab + filter);
    if (res.ok) {
      dispatch(getDashboardSuccess(res.data.data, tab));
      return;
    }
    dispatch(getDashboardFailure(res.data && res.data.message ? res.data.message : null));
  } catch (e) {
    dispatch(getDashboardFailure(e));
  }
};

// get Dashlet data actions
const getDashletRequest = (dash) => ({
  type: actionTypes.GET_DASHLET_REQUEST,
  dash
});

const getDashletSuccess = (payload, dash) => ({
  type: actionTypes.GET_DASHLET_SUCCESS,
  payload,
  dash
});

const getDashletFailure = (error) => ({
  type: actionTypes.GET_DASHLET_FAILURE,
  error,
});

export const getDashlet = (params) => async (dispatch) => {
  let sortBy = params.sortBy ? `sortBy=` + params.sortBy + `&` : "";
  let sortOrder = params.sortOrder ? `sortOrder=` + params.sortOrder + `&` : "";
  let offset = params.offset ? `offset=` + params.offset + `&` : "";
  let dashlet_id = params.dashlet_id ? `dashlet_id=` + params.dashlet_id + `&` : "";
  let group_value = params.group_value ? `group_value=` + params.group_value : "";
  try {
    dispatch(getDashletRequest(params.dashlet_id));
    const res = await api.get(`/V8/dashboard/` + params.tab + `?` + sortBy + sortOrder + offset + dashlet_id + group_value);
    if (res.status === 200) {
      // console.log("getDashlet res.data.data",res.data.data);
      // console.log("url",`/V8/dashboard/` + params.tab + `?` + sortBy + sortOrder + offset + dashlet_id + group_value);
      //set the pageno, sort and search in redux
      res.data.data.dashlets[0].data.data.sortBy= params.sortBy;
      res.data.data.dashlets[0].data.data.sortOrder= params.sortOrder;
      res.data.data.dashlets[0].data.data.offset= params.offset;
      res.data.data.dashlets[0].data.data.group_value= params.group_value;      
      dispatch(getDashletSuccess(res.data.data, params.dashlet_id));
      return res;
    }
    dispatch(getDashletFailure(res.data.message));
  } catch (e) {
    dispatch(getDashletFailure(e));
  }
};

const getNotificationsRequest = () => ({
  type: actionTypes.GET_NOTIFICATIONS_REQUEST,
});

const getNotificationsSuccess = (payload) => ({
  type: actionTypes.GET_NOTIFICATIONS_SUCCESS,
  payload,
});

const getNotificationsFailure = (error) => ({
  type: actionTypes.GET_NOTIFICATIONS_FAILURE,
  error,
});

export const switchNotificationsListener = () => ({
  type: actionTypes.GET_NOTIFICATIONS_FAILURE,
});

export const getNotifications = (page, currentUser
) => async (dispatch) => {
  let tab = "Alerts";
  try {
    dispatch(getNotificationsRequest());

    let url = `/V8/module/${tab}?sort=-date_entered&page[size]=10&page[number]=${page}&filter[is_read][eq]=0&filter[assigned_user_id][eq]=${currentUser}`;
    const res = await api.get(url);
    if (res.ok) {
      dispatch(getNotificationsSuccess(res.data, tab));
      return;
    }
    return dispatch(getNotificationsFailure(getError(res)));
  } catch (e) {
    dispatch(getNotificationsFailure(e));
  }
};

export const downloadFileFromNotification = async (id, module) => {
  try {
    return await api.get(`/V8/meta/download?id=${id}&type=${module}`)
  } catch (e) {
    toast("something went wrong! please try again");
  }
}

export const addToFavouriteRecord = async (recordId, module, is_favs) => {
  try {
    if (is_favs == 0) {
      return await api.post(`/V8/addToFavorites/${module}/${recordId}`, { action: 'add' })
    } else {
      return await api.post(`/V8/addToFavorites/${module}/${recordId}`, { action: 'remove' })
    }
  } catch (e) {
    toast("something went wrong! please try again");
  }
}
const markNotificationAsReadSuccess = (id) => ({
  type: actionTypes.MARK_NOTIFICATION_READ_SUCCESS,
  id
})

export const markNotificationAsRead = (id) => async dispatch => {
  try {
    let res = await api.patch(`/V8/module`, {
      data: {
        type: "Alerts",
        id,
        attributes: {
          is_read: "1",
        },
      },
    });

    if (res.ok) {
      //toast("Notification deleted succesfully");
      dispatch(markNotificationAsReadSuccess(id));
      return;
    }
  } catch (e) {
    //toast("something went wrong! please try again");
  }
};



// add Dashlet data actions
const addDashletRequest = () => ({
  type: actionTypes.ADD_DASHLET_REQUEST,
});

const addDashletSuccess = (payload, tab) => ({
  type: actionTypes.ADD_DASHLET_SUCCESS,
  payload,
  tab
});

const addDashletFailure = (error) => ({
  type: actionTypes.ADD_DASHLET_FAILURE,
  error,
});



export const addActiveDashlet = (dashlet, current_tab, category, webOptions) => async dispatch => {

  let data = [];
  if (category === 'module') {
    data = {
      category: category,
      dashlet_module: dashlet.module_name,
      current_tab: "" + current_tab + "",
      dashlet_id: dashlet,
      position: { 'w': 2, 'h': 2, 'x': 0, 'y': 0, 'i': 0, 'moved': false, 'static': false }
    };
  } else {
    data = {
      category: category,
      dashlet_module: webOptions[dashlet],
      current_tab: "" + current_tab + "",
      dashlet_id: dashlet,
      position: { 'w': 2, 'h': 2, 'x': 0, 'y': 0, 'i': 0, 'moved': false, 'static': false,data:category==='custom'?webOptions:[] }
    }
  }
  try {


    dispatch(addDashletRequest());

    let res = await api.post(`/V8/dashlet/add`, JSON.stringify(data));
    if (res.ok) {
      dispatch(addDashletSuccess(res.data, dashlet));
      return res;
    }
    return dispatch(addDashletFailure(getError(res)));
  } catch (e) {
    dispatch(addDashletFailure(e));
    toast("something went wrong! please try again");
  }
};


const removeDashletRequest = (id) => ({
  type: actionTypes.REMOVEDASHLET_REQUEST,
  id
});

const removeDashletSuccess = (id) => ({
  type: actionTypes.REMOVEDASHLET_SUCCESS,
  id
});

const removeDashletFailure = (error, id) => ({
  type: actionTypes.REMOVEDASHLET_FAILURE,
  error,
  id
});

export const removeDashlet = (params) => async (dispatch) => {
  try {
    dispatch(removeDashletRequest());

    let url = `/V8/dashlet/delete`;
    const res = await api.delete(url, params);
    if (res.status === 200) {
      dispatch(removeDashletSuccess(res.data));
      return res;
    }
    return dispatch(removeDashletFailure(getError(res)));
  } catch (e) {
    dispatch(removeDashletFailure(e));
  }
};
const removeDashboardSuccess = () => ({
  type: actionTypes.REMOVEDASHBOARD_SUCCESS,
});
export const deleteDashboard = (id) => async (dispatch) => {
  try {
   //dispatch(removeDashletRequest());
    let url = `/V8/dashboard/${id}`;    
    const res = await api.delete(url);
    if (res.status === 200) {
      dispatch(removeDashboardSuccess());
      return res;
    }
    //return dispatch(removeDashletFailure(getError(res)));
  } catch (e) {
    //dispatch(removeDashletFailure(e));
  }
};

export const renameDashboard = (id,dashName) => async (dispatch) => {
  try {
    let url = `/V8/dashboard/rename/${id}`;    
    const res = await api.post(url,dashName);
    if (res.status === 200) {
           return res;
    }
   } catch (e) {
    toast("something went wrong! please try again");

  }
};

const saveDashletLayoutRequest = (id) => ({
  type: actionTypes.SAVE_DASHLET_LAYOUT_REQUEST,
  id
});

const saveDashletLayoutSuccess = (id) => ({
  type: actionTypes.SAVE_DASHLET_LAYOUT_SUCCESS,
  id
});

const saveDashletLayoutFailure = (error, id) => ({
  type: actionTypes.SAVE_DASHLET_LAYOUT_FAILURE,
  error,
  id
});


export const saveDashletLayout = (params) => async (dispatch) => {
  try {
    dispatch(saveDashletLayoutRequest());

    let url = `/V8/dashboard/saveLayout`;
    const res = await api.post(url, params);
    if (res.status === 200) {
      dispatch(saveDashletLayoutSuccess(res.data));
      return res;
    }
    return dispatch(saveDashletLayoutFailure(getError(res)));
  } catch (e) {
    dispatch(saveDashletLayoutFailure(e));
  }
};


// add Dashboard  actions
const addDashboardRequest = () => ({
  type: actionTypes.ADD_DASHBOARD_REQUEST,
});

const addDashboardSuccess = (payload) => ({
  type: actionTypes.ADD_DASHBOARD_SUCCESS,
  payload
});

const addDashboardFailure = (error) => ({
  type: actionTypes.ADD_DASHBOARD_FAILURE,
  error,
});



export const addDashboard = (dashName,parentMenuName='') => async dispatch => {

  let data = {
    dashName: dashName,
    parentMenuName:parentMenuName
  };
  try {
    dispatch(addDashboardRequest());
    let res = await api.post(`/V8/dashboard/add`, JSON.stringify(data));
    if (res.ok) {
      dispatch(addDashboardSuccess(res));
      return res;
    }
    return dispatch(addDashboardFailure(getError(res)));
  } catch (e) {
    dispatch(addDashboardFailure(e));
    toast("something went wrong! please try again");
  }
};



// Edit Dashlet actions
const editDashletRequest = () => ({
  type: actionTypes.EDIT_DASHLET_REQUEST,
});

const editDashletSuccess = (payload) => ({
  type: actionTypes.EDIT_DASHLET_SUCCESS,
  payload
});

const editDashletFailure = (error) => ({
  type: actionTypes.EDIT_DASHLET_FAILURE,
  error,
});



export const editDashlet = (params) => async dispatch => {

  let data = {
    "dashlet_module": 'HomeApp',
    "dashlet_id": params.data.id
  };
  try {
    dispatch(editDashletRequest());
    let res = await api.get(`/V8/dashlet/edit`, data);
    if (res.ok) {
      dispatch(editDashletSuccess(res.data));
      return res;
    }
    return dispatch(editDashletFailure(getError(res)));
  } catch (e) {
    dispatch(editDashletFailure(e));
    toast("something went wrong! please try again");
  }
};


// Configure Dashlet actions
const configureDashletRequest = () => ({
  type: actionTypes.CONFIGURE_DASHLET_REQUEST,
});

const configureDashletSuccess = (payload) => ({
  type: actionTypes.CONFIGURE_DASHLET_SUCCESS,
  payload
});

const configureDashletFailure = (error) => ({
  type: actionTypes.CONFIGURE_DASHLET_FAILURE,
  error,
});



export const configureDashlet = (params) => async dispatch => {

  try {
    dispatch(configureDashletRequest());
    let res = await api.post(`/V8/dashlet/configure`, params);
    if (res.ok) {
      dispatch(configureDashletSuccess(res.data));
      return res.data;
    }
    return dispatch(configureDashletFailure(getError(res)));
  } catch (e) {
    dispatch(configureDashletFailure(e));
    toast("something went wrong! please try again");
  }
};

export const getCalculatedData = (params) => async dispatch => {
  console.log("params",JSON.stringify({filter:params}))
  
  try {
    let res = await api.post(`/V8/calculator`,JSON.stringify({filter:params}));
    if (res.ok) {
      return res.data;
    }
  } catch (e) {
    toast("something went wrong! please try again");
  }
};


export const getCustomReport = (params,allTabFilter) => async dispatch => {
params['allTabFilter']=allTabFilter;
  try {
    let res = await api.post(`/V8/dashboard/customReport`, JSON.stringify({filter:params}));
    if (res.ok) {
      return res;
    }
  } catch (e) {
    toast("something went wrong! please try again");
  }
};



const storeStateRequest = () => ({
  type: actionTypes.STORE_STATE_REQUEST,
});

const storeStateSuccess = (payload) => ({
  type: actionTypes.STORE_STATE_SUCCESS,
  payload
});

const storeStateFailure = (error) => ({
  type: actionTypes.STORE_STATE_FAILURE,
  error,
});

export const getCurlCall = (params,allTabFilter) => async dispatch => {
 
  params['allTabFilter']=allTabFilter;
    try {
      dispatch(storeStateRequest());

      let res = await api.post(`/V8/dashboard/curlCall`, JSON.stringify({filter:params}));
      if (res.ok) {
        dispatch(storeStateSuccess(['xirr',res.data]));
   
        return res;
      }
    } catch (e) {
      dispatch(storeStateFailure(e));

      toast("something went wrong! please try again");
    }

     };
  
     export const setUserTabs = (params) => async dispatch => {
        try {
          let res = await api.post(`/V8/dashboard/manageTabs`, JSON.stringify({tabs:params}));
          if (res.ok) {
            return res;
          }
        } catch (e) {
          toast("something went wrong! please try again");
        }
    
         };
      